export default "__VITE_ASSET__2299099e__"